//import {storge, database} from '../firebase/firebase';

// ADD_SETTINGS
export const addSettingsData = (data) => ({
  type: 'ADD_SETTINGS',
  data
});




// WEBPACK FOOTER //
// ./src/actions/settings.js